<template>
  <div>
    <div
      class="items"
      v-for="(item,index) in text.datas"
      :key="item.id"
    >
      <!-- 控制显示top图片 -->
      <div
        v-if="index==0"
        class="item-img"
      >
        <img
          src="../../../../../../assets/img/imgH5/images/share/top1.png"
          alt=""
        >
      </div>
      <div
        v-if="index==1"
        class="item-img"
      >
        <img
          src="../../../../../../assets/img/imgH5/images/share/top2.png"
          alt=""
        >
      </div>
      <div
        v-if="index==2"
        class="item-img"
      >
        <img
          src="../../../../../../assets/img/imgH5/images/share/top3.png"
          alt=""
        >
      </div>
      <div
        v-if="index==3"
        class="item-img"
      >
        <img
          src="../../../../../../assets/img/imgH5/images/share/top4.png"
          alt=""
        >
      </div>
      <div
        v-if="index==4"
        class="item-img"
      >
        <img
          src="../../../../../../assets/img/imgH5/images/share/top5.png"
          alt=""
        >
      </div>
      <div
        v-if="index==5"
        class="item-img"
      >
        <img
          src="../../../../../../assets/img/imgH5/images/share/top6.png"
          alt=""
        >
      </div>
      <div
        v-if="index==6"
        class="item-img"
      >
        <img
          src="../../../../../../assets/img/imgH5/images/share/top7.png"
          alt=""
        >
      </div>
      <div
        v-if="index==7"
        class="item-img"
      >
        <img
          src="../../../../../../assets/img/imgH5/images/share/top8.png"
          alt=""
        >
      </div>
      <div
        v-if="index==8"
        class="item-img"
      >
        <img
          src="../../../../../../assets/img/imgH5/images/share/top9.png"
          alt=""
        >
      </div>
      <div
        v-if="index==9"
        class="item-img"
      >
        <img
          src="../../../../../../assets/img/imgH5/images/share/top10.png"
          alt=""
        >
      </div>
      <div class="item-concat">
        <a
          :href="item.url"
          target="_blank"
          @click.prevent="copyUrl(item.url)"
        >
          <p class="p1">{{item.title}}</p>
          <span>{{item.author}}/相似{{item.reprintNumb}}</span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["topList"],
  data() {
    return {
      text: {
        datas: []
      }
    };
  },
  methods: {
    copyUrl(url) {
      var oInput = document.createElement("input"); //创建隐形input
      oInput.value = url; // 复制链接到剪切板
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy");
      oInput.remove();
      this.$message({
        message: "复制链接成功",
        type: "success",
        offset: 240,
        duration: 3000,
        customClass:"msg_H5"
      });
    }
  },
  watch: {
    topList(newval) {
      console.log(newval);
      this.text.datas = newval;
    }
  }
};
</script>
<style lang="scss" scoped>
.items {
  display: flex;
  height: 20rem;
  border-bottom: 1px solid #e8e8e8;

  .item-img {
    width: 20%;
    padding-top: 1rem;
    text-align: center;

    img {
      // width: 50px;
      // height: 50px;
      width: 18rem;
      height: 18rem;
    }
  }
  .item-concat {
    height: 100%;
    width: 80%;
    a {
      text-decoration: none;
      display: flex;
      height: 100%;
      flex-direction: column;
      justify-content: space-around;
      p {
        color: black;
      }
      span {
        color: #c1c1c1;
        font-size: 12px;
      }
    }
  }
}

</style>
<style>
.msg_H5{
  min-width: auto;
}
</style>